import { connect } from 'react-redux';

import './PageContainer.scss';

const PageContainer = ({ children, loggedIn }) => {
  return (
    <div className="gm-page-container">
      <div className="gm-page-body">{children}</div>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  loggedIn: state.user.loggedIn,
});

export default connect(mapStateToProps)(PageContainer);
